import { render, staticRenderFns } from "./KinvaTemplate.vue?vue&type=template&id=0e456968&scoped=true"
import script from "./KinvaTemplate.vue?vue&type=script&lang=js"
export * from "./KinvaTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e456968",
  null
  
)

export default component.exports